import * as React from "react"

import { cva } from "../cva.ts"
import { withClass } from "../to-wrapped-children.ts"

export const Fieldset = ({ ref, ...props }: Fieldset.Props) => (
  <div {...withClass(props, classForFieldset)} ref={ref} />
)

export namespace Fieldset {
  export interface Props extends React.ComponentProps<"div"> {}
}

export const classForFieldset = cva(["flex flex-col gap-6"])
